import { StatusRepository } from '@core/repositories/status.repository';
import { State } from '@shared/interfaces/state';
import { Observable, of, throwError } from 'rxjs';

interface ResultStatus {
  id: string;
  attributes: {
    name: string;
  };
}

export class FakeStatusRepository implements StatusRepository {
  url: string;

  dataStatus: Array<ResultStatus> = [
    {
      id: '301',
      attributes: {
        name: 'Estado1'
      }
    },
    {
      id: '401',
      attributes: {
        name: 'Estado2'
      }
    },
    {
      id: '501',
      attributes: {
        name: 'Estado3'
      }
    }
  ];

  status = {
    data: this.dataStatus
  };

  getItems(): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(this.status);
  }

  add(state: State): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  edit(state: State): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  delete(item: any): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }
}
